import ApiService from '@/core/services/api.service';

const commonMixin = {
  created: function () {},
  methods: {
    fetchStores: async function () {
      return ApiService.get('/stores/getStores').then((response) => {
        return response.data;
      });
    },
    fetchOrderSources() {
      const params = {
        status: 1,
      };
      return ApiService.query('/v1/order-sources', {
        params: params,
      }).then((response) => {
        return response?.data?.data?.list_order_source || [];
      });
    },
    fetchStoreByUser() {
      return ApiService.get(`v1/stores/get-by-user`).then(({ data }) => {
        const stores = data.data.stores || [];
        const currentStore = stores.find(
          (store) => store.id === data.data.storeId,
        );
        return {
          stores: stores,
          currentStoreId: currentStore?.id || null,
          currentStoreName: currentStore?.name || '',
          currentStoreShortName: currentStore?.shortName || '',
        };
      });
    },
    fetchJobTitles: async function () {
      return ApiService.get('v1/job-titles').then((response) => {
        return response.data.data || [];
      });
    },
    fetchDepartments: async function () {
      return ApiService.get('v1/employees/departments').then((response) => {
        return response.data.data || [];
      });
    },
    fetchCompanies: async function () {
      return ApiService.get('v1/companies/all').then((response) => {
        return response.data.data || [];
      });
    },
  },
};
export default commonMixin;
